module.exports = __webpack_public_path__ + "img/35.16489951.png";